// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add a margin below the dropdown to create space */
.dropdown-container {
    margin-bottom: 15px; /* Adjust the value as needed */
    background: darkslategray;
  }

  .uap-submit-button {
    list-style-type: none;
    padding: 0;
    margin-right: 20px;
    margin-top: 20px;
    border-radius: 20px;
    background: black;
    color: white;
    width: 100px;
    height: 50px;
  }  

  .ua-Popup-window-h2 {
    margin-bottom: 20px;
    color: white;
    font-size: 24px;
  }

  .ua-profile-action-btn {
    padding: 10px 20px;
    cursor: "pointer";
    transition: "background-color 0.3s ease";
  }


  .ua-profile-action-btn:hover {
    background: green;
  }

  .ua-profile-action-container {
    background: rgb(34, 31, 31);
    box-shadow: 1px 1px 3px white;
    color: white;
  }
`, "",{"version":3,"sources":["webpack://./src/components/common/ProfileButton/PopupWithDropdown.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,mBAAmB,EAAE,+BAA+B;IACpD,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;EAC1C;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,YAAY;EACd","sourcesContent":["/* Add a margin below the dropdown to create space */\n.dropdown-container {\n    margin-bottom: 15px; /* Adjust the value as needed */\n    background: darkslategray;\n  }\n\n  .uap-submit-button {\n    list-style-type: none;\n    padding: 0;\n    margin-right: 20px;\n    margin-top: 20px;\n    border-radius: 20px;\n    background: black;\n    color: white;\n    width: 100px;\n    height: 50px;\n  }  \n\n  .ua-Popup-window-h2 {\n    margin-bottom: 20px;\n    color: white;\n    font-size: 24px;\n  }\n\n  .ua-profile-action-btn {\n    padding: 10px 20px;\n    cursor: \"pointer\";\n    transition: \"background-color 0.3s ease\";\n  }\n\n\n  .ua-profile-action-btn:hover {\n    background: green;\n  }\n\n  .ua-profile-action-container {\n    background: rgb(34, 31, 31);\n    box-shadow: 1px 1px 3px white;\n    color: white;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
